const getIcsCalendar = (appointment) => {
  const elements = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "BEGIN:VEVENT",
    "CLASS:PUBLIC",
    "DESCRIPTION:" + appointment.description,
    "DTSTART;VALUE=DATE:" + appointment.startDateTime,
    "DTEND;VALUE=DATE:" + appointment.endDateTime,
    "LOCATION:" + appointment.location,
    "SUMMARY;LANGUAGE=en-us:" + appointment.title,
    "TRANSP:TRANSPARENT",
    "END:VEVENT",
    "END:VCALENDAR"
  ];

  return elements.join("\n");
};

const getYahooCalendarUrl = (appointment) => {
  let yahooCalendarUrl = "http://calendar.yahoo.com/?v=60&view=d&type=20";
  yahooCalendarUrl += "&title=" + encodeURI(appointment.title);
  yahooCalendarUrl +=
    "&st=" +
    encodeURI(appointment.startDateTime) +
    "&et=" +
    encodeURI(appointment.endDateTime);
  yahooCalendarUrl += "&desc=" + encodeURI(appointment.description);
  yahooCalendarUrl += "&in_loc=" + encodeURI(appointment.location);

  return yahooCalendarUrl;
};

const getGoogleCalendarUrl = (appointment) => {
  let googleCalendarUrl =
    "https://www.google.com/calendar/render?action=TEMPLATE";
  googleCalendarUrl += "&text=" + encodeURI(appointment.title);
  googleCalendarUrl +=
    "&dates=" +
    encodeURI(appointment.startDateTime) +
    "/" +
    encodeURI(appointment.endDateTime);
  googleCalendarUrl += "&details=" + encodeURI(appointment.description);
  googleCalendarUrl += "&location=" + encodeURI(appointment.location);

  return googleCalendarUrl;
};

const getMicrosoftCalendarUrl = (appointment) => {
  var microsoftCalendarUrl =
    "http://calendar.live.com/calendar/calendar.aspx?rru=addevent";
  microsoftCalendarUrl += "&summary=" + encodeURI(appointment.title);
  microsoftCalendarUrl +=
    "&dtstart=" +
    encodeURI(appointment.startDateTime) +
    "&dtend=" +
    encodeURI(appointment.endDateTime);
  microsoftCalendarUrl += "&description=" + encodeURI(appointment.description);
  microsoftCalendarUrl += "&location=" + encodeURI(appointment.location);

  return microsoftCalendarUrl;
};

const printConfirmation = () => {
  var printContents = document.getElementById("printable").innerHTML;
  var popupWin = window.open("", "_blank", "width=790,height=770");
  popupWin.document.open();
  popupWin.document.write(
    `<link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700" rel="stylesheet" type="text/css">
    <script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/20/16/common.js"></script>
    <script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/20/16/map.js"></script>
    <script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/20/16/util.js"></script>
    <script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/20/16/onion.js"></script>
    <script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/20/16/controls.js"></script>
    <script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/20/16/stats.js"></script>
    <script type="text/javascript" charset="UTF-8" src="https://maps.googleapis.com/maps-api-v3/api/js/20/16/marker.js"></script>
    <style type="text/css">
    .hidden-print {
      display: none !important;
    }
    .box-header {
      text-align: center;
      margin-bottom: 50px;
    }
    .box-header h3 {
      font-weight: 500;
      font-size: 26px;
      margin: 0.8em 0 0.5em;
      text-transform: uppercase;
      line-height: 1.2em;
    }
    .box-header p {
      font-weight: 300;
      line-height: 1.5em;
    }
    .box-content {
      padding: 0 5px;
    }
    .row {
      margin-right: -15px;
      margin-left: -15px;
    }
    .row:after {
      clear: both;
      display: table;
      content: "";
    }
    .col-sm-7 {
      width: 58.33333333%;
      float: left;
    }
    .col-sm-5 {
      width: 41.66666667%;
      float: left;
    }
    .box-content .map-container {
      padding: 1em;
      background: #fff;
    }
    .google-map-container {
      width: 100%;
      height: 320px;
    }
    .booking-details {
      margin-bottom: 20px;
    }
    .booking-details li {
      margin-bottom: 10px;
      list-style: none;
    }
    .detail-label {
      font-size: 0.9em;
      font-weight: 300;
      color: #676767;
      line-height: 1.2em;
    }
    .detail-content {
      font-weight: 400;
      font-size: 1.1em;
      line-height: 1.5em;
    }
    .booking-confirmation-wrap {
      padding-top: 131px;
    }
  	.hidden-print {
  		display: none !important;
  	}
  	@media print {
		.col-sm-7, .col-sm-5 {
			width: 350px;
			float: left;
		}
		.booking-confirmation-wrap {
			padding-top: 131px;
		}
	}
	</style>
	</head><body style="overflow-x:hidden;" onload="window.print()">
	<div class="narrative-completed personal-details-completed" id="main">
	<div class="booking-confirmation-wrap">${printContents}</div></div></html>`
  );
  popupWin.document.close();
};

export {
  getIcsCalendar,
  getYahooCalendarUrl,
  getGoogleCalendarUrl,
  getMicrosoftCalendarUrl,
  printConfirmation
};



// WEBPACK FOOTER //
// ./src/modules/Confirm/components/Helper/index.js